export default __webpack_public_path__ + "static/media/EuclidFlex-Light.26da4de7.otf";